// @ts-nocheck

export type StorefrontPremadeStoriesListAgeGroup =
  typeof StorefrontPremadeStoriesListAgeGroup[keyof typeof StorefrontPremadeStoriesListAgeGroup];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontPremadeStoriesListAgeGroup = {
  baby: "baby",
  child: "child",
  toddler: "toddler",
} as const;
